// @flow
import React, {useEffect, useState} from 'react';
import {useCookies} from 'react-cookie';
import {Redirect, useHistory, useParams} from "react-router-dom";
import Header from "../Header";
import BackButton from "../../GUI_COMMON/COMPONENTS/BackButton";
import TextInput from "../../GUI_COMMON/COMPONENTS/TextInput";
import LIButton from "../../GUI_COMMON/COMPONENTS/LIButton";
import Popup from "../../GUI_COMMON/COMPONENTS/Popup";
import ArchiverClientApi from "../../API/archiverClientApi";
import ErrorPopup from "../../GUI_COMMON/COMPONENTS/ErrorPopup";
import CheckInput from "../../GUI_COMMON/COMPONENTS/CheckInput";
import DigitInput from "../../GUI_COMMON/COMPONENTS/DigitInput";
import ArchiverGuiUtils from "../../SUPPORT/ArchiverGuiUtils";
import LIUtils from "../../GUI_COMMON/SUPPORT/LIUtils";
import LocationSelector from "../LocationSelector";
const DevicesAdminPage = () => {

    /**
     * these are hardcoded into the archiver -- don't change
     * @type {[{deviceType: number, name: string},]}
     */
    const DEVICE_TYPES = [
        {deviceType:2,name:"Block Track"},
        {deviceType:1,name:"Slide Track"},
        {deviceType:3,name:"Slide Scan"},
        {deviceType:5,name:"Rack Track"},
        {deviceType:6,name:"Label Printer"},            // not profile based
        {deviceType:4,name:"Mapper"},
        {deviceType:7,name:"Processor"},
    ];
    const PRINTER_DEVICE_TYPE = 6; // this matches above
    
    const {deviceId} = useParams();
    const history = useHistory();
    const [cookies,] = useCookies();
    
    const [curDeviceDetails, setCurDeviceDetails] = useState(getDefaultDeviceDetails());
    const [fullDeviceList, setFullDeviceList] = useState([]);
    
    const [isDirty, setIsDirty] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [isRemoving, setIsRemoving] = useState(false);
    const [isServiceLevel] = useState(LIUtils.UserHasLevel(cookies,"SERVICE")); // for disabling things

    const [redirectToPage, setRedirectToPage] = useState();
    const [deviceFromUrl, setDeviceFromUrl] = useState(deviceId);
    //const [locationIsValid, setLocationIsValid] = useState(false);

    useEffect(() => {
        console.debug("refreshing devices list");
        getDeviceList();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect( () => {
        sortDeviceList(fullDeviceList);
        if(fullDeviceList && fullDeviceList.length>0 && !isDirty) {
            
            doRealListItemClicked(deviceFromUrl?Number(deviceFromUrl):null);  // preselect if the url has soemthign in it.
        }
    },[fullDeviceList]);  // eslint-disable-line react-hooks/exhaustive-deps
    
    function getDefaultLocationDetails() {
        // DepartmentWithLocation class (we care only about location.id and department.id)
        return { "location": { id: -1}, "department": { id: -1 } };   
    }
    
    function getDefaultDeviceDetails():{} {
        return(
            {
                id: null,
                name: "",
                ipAddress:"",
                deviceType: -1,
                accessCode: "",
                enabled: true,
                profiles: null,
                location: getDefaultLocationDetails(),
            }
        );
    }
    
    function getDeviceList() {
        setIsLoading(true);
        ArchiverClientApi.getDevices() 
        .then( (devices) => {
            setFullDeviceList(devices);
        })
        .catch( responseError => ArchiverGuiUtils.ShowErrorIfNotUnauthourized(responseError))
        .finally( () => {
            setIsLoading(false);
        });
    }
    
    function handleCancelClicked(e) {
        e.preventDefault();
        e.stopPropagation();
        
        confirmClearDirty();
    }
    
    function confirmClearDirty() {
        if(isDirty) {
            Popup.showConfirm("Cancel?","You have changed some information.","Forget changes",null,
                () => {
                    resetDeviceDetailsShown();
                });
        }
        else {
            resetDeviceDetailsShown(); // just clear what's there
        }
    }
    
    function handleDeleteDeviceClicked(e) {
        e.preventDefault();
        e.stopPropagation();
        
        Popup.showConfirm("Delete Device?",`<p>This will remove '${curDeviceDetails.fullName}' completely the system.</p>`+
                                "<p>Are you sure you want to do this?</p>","Yes, Delete it",null, 
            () => {
               doDeviceRemove(curDeviceDetails.fullName,curDeviceDetails.id);
            });
    }
   
    function doDeviceRemove(deviceName, deviceId) {
        setIsRemoving(true);
        ArchiverClientApi.sendDeviceRemove(deviceId)
        .then(() => {
            Popup.showInfo(`Device '${deviceName}' removed`);
            removeFromDeviceList(deviceId);
            resetDeviceDetailsShown();
        })
        .catch(responseError => ArchiverGuiUtils.ShowErrorIfNotUnauthourized(responseError))
        .finally(() => {
            setIsRemoving(false);
        });
    }
    
    function handleSaveClicked(e,action) {
        e.preventDefault();
        e.stopPropagation();
        
        const notValidMsg=checkForValid();
        if(notValidMsg) {
            ErrorPopup.showError("Validation Problem", notValidMsg);
            return;
        }
       
        setIsSaving(true);
        ArchiverClientApi.sendDeviceUpdate(curDeviceDetails)
        .then( (savedDeviceDetails) => {
            Popup.showInfo(`Device '${curDeviceDetails.fullName}' Saved`);
            if(action==="ADD") {
                addToFullDeviceList(savedDeviceDetails);
                resetDeviceDetailsShown();
            }
            else if(action==="UPDATE") {
                updateExistingDevice(savedDeviceDetails);
                setIsDirty(false);
            }
            setDeviceFromUrl(savedDeviceDetails.id); // update the url so we can select it
        })
        .catch( responseError => ArchiverGuiUtils.ShowErrorIfNotUnauthourized(responseError))
        .finally( () => {
           setIsSaving(false); 
        });
    }
    
    function checkForValid():string|null {
        let isValid = true;
        let notValidMsg = "";
        const typeSelect = Number(document.getElementById("deviceType").value);
        if (!document.getElementsByName("fullName")[0].checkValidity()) {
            isValid = false;
            notValidMsg = "Name needs to be non-blank";
        } else if (typeSelect === -1) {
            isValid = false;
            notValidMsg = "Device type needs to be selected";
        } else if (!document.getElementsByName("accessCode")[0].checkValidity()) {
            isValid = false;
            notValidMsg = "Access Code needs to be non-blank and made up of 6 digits";
        }
        // devices must have a location and a department
        if (!curDeviceDetails.location?.location?.id || curDeviceDetails.location?.location?.id === -1 || !curDeviceDetails.location?.department || curDeviceDetails.location?.department.id === -1) {
            isValid = false;
            notValidMsg = "Devices must have a location";
        }

        if (!isValid) {
            return notValidMsg;
        }
        return null;
    }
    
    function locationIsRequired():boolean {
        
        // simple for now
        return curDeviceDetails.deviceType===PRINTER_DEVICE_TYPE;
    }
    
    function addToFullDeviceList(deviceDetails) {
        const curDeviceList = [...fullDeviceList];
        curDeviceList.push(deviceDetails);
        setFullDeviceList(curDeviceList);
    }
    
    function sortDeviceList(deviceList) {
        if(deviceList) {
            deviceList.sort((a, b) => {
                if (a.fullName.toLowerCase() < b.fullName.toLowerCase()) {
                    return -1;
                }
                if (a.fullName.toLowerCase() > b.fullName.toLowerCase()) {
                    return 1;
                }
                return 0;
            });
        }
    }

    function removeFromDeviceList(deviceId) {
        const curList = fullDeviceList.filter( item => item.id !== deviceId);
        setFullDeviceList(curList);
    }
    
    function updateExistingDevice(details) {
        const curList = [...fullDeviceList];
        let thisDeviceIndex = curList.findIndex(item => item.id===details.id);
        curList[thisDeviceIndex]=details;
        sortDeviceList(curList);
        setFullDeviceList(curList);
    }
    
    function onChange(e) {
        const thing = e.target.name;
        const editInfo = {...curDeviceDetails};
        if(e.target.type==="checkbox") { // this is a checkbox
            editInfo[thing] = e.target.checked;
        }
        else {
            let value = e.target.value;
            let locationEditInfo = {...curDeviceDetails.location}??getDefaultLocationDetails();

            // the device type selector has its own names for fields - we remap
            if(thing==="deviceType") { // value here is the id selected
                value = Number(value);
                if(value===editInfo.type) { // no change
                    return;
                }
                editInfo.deviceType=value;
            }
            else if(thing==="toLocation-destLocation") { // value here is the id selected
                const locId = Number(value);
                if(isNaN(locId)) {
                    locationEditInfo = getDefaultLocationDetails(); // reset fully
                }
                else {
                    locationEditInfo = getDefaultLocationDetails(); // reset fully
                    locationEditInfo.location.id=locId;
                }
                editInfo.location=locationEditInfo;
            }
            else if(thing==="toLocation-destDepartment") { // value here is the id selected
                const deptId = Number(value);
                if(!isNaN(deptId)) {
                    locationEditInfo.department.id = Number(value);
                    editInfo.location = locationEditInfo;
                }
            }
            else {
                editInfo[thing] = value;
            }
        }
        setCurDeviceDetails(editInfo);
        setIsDirty(true);
    }
    
    function showDeviceList(listContents) {

        if(isLoading) {
            return <div className="pr-4 w-30 li-border-right-light">...loading...</div>;
        }
        
        let resultList = listContents?.map((item,index) => {
            let extraClass="";
            if(curDeviceDetails?.id===item.id) {
                extraClass=" li-bg-light";
            }
                return <li key={index} className={"list-group-item li-pointer "+(item.enabled===false?"li-strike-through":"")+extraClass}
                    onClick={() => handleListItemClicked(item)}>{item.fullName}</li>;
            }
        );
        if(!resultList || resultList.length===0) {
            resultList = "no devices found";
        }
        return (
            <div className="pr-4 w-30 li-border-right-light">
                <h4>Devices</h4>
                <div className="li-scrollable-at-500 ">
                    <ul className="list-group-flush li-list-group-w-hover pl-0">
                        {resultList}
                    </ul>
                    <div className="li-border-line-light"/>
                </div>
                <LIButton small primary label="" bgClass={isRemoving?"m-3":"fa fa-trash my-3 ml-3"} disabled={curDeviceDetails?.id===null || !isServiceLevel}
                          onClick={handleDeleteDeviceClicked} showBusy={isRemoving}/>
                <LIButton small primary label="" bgClass={isRemoving?"":"fa fa-plus m-3"} onClick={confirmClearDirty} showBusy={false}
                          disabled={!isServiceLevel}/>
            </div>
        );
    }
    
    function handleListItemClicked(item) {
        if(isDirty) {
            Popup.showConfirm("Cancel?","You have changed some information.","Forget changes",null,
                () => {
                    resetDeviceDetailsShown();
                    doRealListItemClicked(item.id);
                });
        }
        else {
            doRealListItemClicked(item.id);
        }
    }
    
    function doRealListItemClicked(itemId) {
        const device = fullDeviceList.filter(i => i.id===itemId);
        if(device.length===0) {
            resetDeviceDetailsShown();
        }
        else {
            setCurDeviceDetails(device[0]);
            updateUrlLink(`/admin/devices/${device[0].id}`);
        }
    }

    function updateUrlLink(toThis) {
        history.replace(toThis);
    }
    
    function resetDeviceDetailsShown() {
        setCurDeviceDetails(getDefaultDeviceDetails());
        setIsDirty(false);
        updateUrlLink("/admin/devices");
        
        // focus the first input field
        const nameEl = document.getElementsByName("fullName")[0];
        if(nameEl) {
            nameEl.focus();
        }
    }
    
    function dumpDeviceTypeOptionsList() {
        return DEVICE_TYPES.map(item => <option key={item.deviceType} value={item.deviceType}>{item.name}</option>);
    }
    
    //#region PROFILES
    function handleSetProfilesClicked() {
        const deviceId = curDeviceDetails.id;
        setRedirectToPage("/admin/set_profiles/"+deviceId);
    }

    function getProfilesLabel() {
        //const numProfiles = curDeviceDetails?.profiles?.length??0;
        return(
            `Assign Profiles` // (${numProfiles})`
        );
    }

    function disableProfileButtons() {
        if(curDeviceDetails?.id===null) { // new device 
            return true;  // disabled
        }

        return false; // enabled!
    }

    function deviceTypeIsNotProfileBased() {

        // some devices are not profile-based
        // so we don't want to show the "Assign Profiles" button
        const labelPrinterTypeId = DEVICE_TYPES.find(item => item.name==="Label Printer")?.deviceType;
        const slideMapperTypeId = DEVICE_TYPES.find(item => item.name==="Mapper")?.deviceType;
        const processorTypeId = DEVICE_TYPES.find(item => item.name==="Processor")?.deviceType;
        return curDeviceDetails?.deviceType===labelPrinterTypeId || curDeviceDetails?.deviceType===slideMapperTypeId ||
            curDeviceDetails?.deviceType===processorTypeId;
    }
    //#endregion PROFILES

    //#region PROFILE_SETS

    function handleSetProfileSetsClicked() {
        setRedirectToPage(`/admin/assign_profilesets/${curDeviceDetails.id}/${encodeURIComponent(curDeviceDetails.fullName)}`);
    }

    function getProfileSetsLabel() {
        return(
            `Assign Profile Sets`
        );
    }
    
    //#endregion PROFILE_SETS
    
    function handleBackClicked() {
        if(isDirty) {
            Popup.showConfirm("Cancel?","You have changed some information.","Forget changes",null,
                () => {
                    setRedirectToPage("/adminPage");
                });
        }
        else {
            history.goBack();
        }
    }

    if (redirectToPage) {
        return <Redirect to={redirectToPage}/>;
    }
    
    function isAccessCodeGood() {
        const code = curDeviceDetails?.accessCode;
        if(!code) {
            return ""; // neither good nor bad (not completed)
        }
        return curDeviceDetails?.accessCode.length===6?"good":"bad"
    }
    
    function addUpdateIsDisabled() {
        return !isDirty || isSaving || checkForValid()!==null;
    }
    
    return (
        <div className="container">
            <Header hideAdmin/>
            <div className="li-header-row">
                <BackButton onClick={handleBackClicked}/>
                <h1 className="ml-4 d-inline-block align-middle">Device Administration</h1>
            </div>
            
            <div className="row">
                {/* LEFT SIDE LIST */}
                {showDeviceList(fullDeviceList)}

                {/* RIGHT SIDE FORM */}
                <div className="pl-4 w-60">
                    <div className="row p-0 m-0 justify-content-between">
                        <div className="li-fg-danger li-font-small text-left col-11">* <b>Service Level</b> access is required to change device details on this page.</div>
                        <div className="li-fg-slightly-muted li-font-small text-right col-1">[Id:{curDeviceDetails?.id??"-"}]</div>
                    </div>
                    <div className="row p-0 m-0 justify-content-between">
                        {/* right side, row #1 */}
                        <TextInput name="fullName" label="Name" onChange={(e)=>onChange(e)}
                                   placeholder="" textLeft
                                   value={curDeviceDetails?.fullName??""}
                                   required
                                   disabled={!isServiceLevel}/>
                        <CheckInput label="Enabled" name="enabled" checked={curDeviceDetails.enabled} onChanged={(e)=>onChange(e)} disabled={!isServiceLevel}/>
                    </div>
                    {/* left side, row #2 */}
                    <label htmlFor="deviceType" className="li-form-label mr-3">Device Type</label>
                    <select onChange={onChange} id="deviceType" name="deviceType" value={curDeviceDetails.deviceType??-1} 
                            className="li-form-field no-width align-self-end li-border-dark" required={true} disabled={!isServiceLevel}>
                        <option value={-1} disabled>(select a type)</option>
                        {dumpDeviceTypeOptionsList()}
                    </select>

                    {/* right side, row #3 */}
                    <TextInput name="ipAddress" label="IP Address" onChange={(e)=>onChange(e)} placeholder=""  
                               value={curDeviceDetails?.ipAddress??""} oneRow disabled={!isServiceLevel}
                                helpText="* this should include the port number if required (ex: ':9100' for printers)"/>
                    { /* right side, row #4 */}
                    <DigitInput name="accessCode" label="Access Code" value={curDeviceDetails?.accessCode??""} oneRow
                              onChange={(e)=>onChange(e)} required minLength={6} maxLength={6} goodNess={isAccessCodeGood()}
                                helpText="*6 digits is required" disabled={!isServiceLevel}/>
                    { /* right side, row #5 - location */}
                            <LocationSelector name="toLocation" onChange={onChange} locationLabel="Location"
                                              locationValue={curDeviceDetails.location?.location?.id}
                                              departmentValue={curDeviceDetails.location?.department?.id}
                                              showContact={false}
                                              readOnly={!isServiceLevel}
                                              required={locationIsRequired() || (curDeviceDetails?.location?.location && curDeviceDetails?.location?.location?.id!==-1)}
                                              withDepartmentsOnly/>
                    <hr/>
                    {/* right side, row #5 - profiles and profile sets*/}
                    <div className="my-4" hidden={deviceTypeIsNotProfileBased()}>
                        <div className="row justify-content-around">
                            <div className="col align-self-center text-center">
                                <LIButton name="profilesets" label={getProfileSetsLabel()} bgClass="" fitHeight secondary
                                          disabled={disableProfileButtons()}
                                          onClick={handleSetProfileSetsClicked}/>
                            </div>
                            <div className="col-sm-12 text-center col-md-2 col-lg-1 align-self-center">
                                <span className="font-weight-bolder">OR</span>
                            </div>
                            <div className="col align-self-center text-center">
                                <LIButton name="profiles" label={getProfilesLabel()} bgClass="" fitHeight
                                          disabled={disableProfileButtons()}
                                          onClick={handleSetProfilesClicked}/>
                            </div>
                        </div>
                        <div className="li-font-small pt-5"><b>*NOTE:</b> If at least one Profile Set is assigned, the profiles setup in "Assigned Profiles" will be ignored.</div>
                    </div>
                    
                    {/* BUTTON ROW */}
                    <div className="text-center my-5">
                        <LIButton name="cancel" label={isDirty?"Cancel":"Clear"} bgClass="mr-4" primary onClick={handleCancelClicked}/>
                        <LIButton name="save" label={curDeviceDetails?.id===null?"ADD":"UPDATE"} secondary disabled={addUpdateIsDisabled()} 
                                  onClick={(e)=>handleSaveClicked(e,curDeviceDetails?.id===null?"ADD":"UPDATE")} showBusy={isSaving}/>
                    </div>
                </div>
            </div>

            
        </div>
    );
}

DevicesAdminPage.propTypes = {
   
};

export default DevicesAdminPage;